import {
    MutationKey,
    useMutation,
    UseMutationOptions,
    UseMutationResult,
} from "@tanstack/react-query";

export const useMutationRequestQuery = <
    TData,
    TError,
    TVariables = unknown,
    TContext = unknown
>(
    mutationKey: string | readonly unknown[],
    mutationFn: (variables: TVariables) => Promise<TData>,
    options: UseMutationOptions<TData, TError, TVariables, TContext> = {}
): UseMutationResult<TData, TError, TVariables, TContext> => {
    const normalizedKey: MutationKey =
        typeof mutationKey === "string" ? [mutationKey] : mutationKey;

    return useMutation<TData, TError, TVariables, TContext>({
        mutationKey: normalizedKey,
        mutationFn,
        ...options,
    });
};
